/* eslint-disable no-redeclare */
/**
 * @See https://github.com/healthcarecom/sem-content#get-campaign-of-calls
 */

import type { CallType, CampaignPlacement } from '@hc-frontend/core-types';
import { z } from 'zod';

export const CallCampaignProductType = z.enum([
  'HEALTH',
  'MEDICARE',
  'MEDICARE_ADVANTAGE',
  'MEDICARE_SUPPLEMENT',
  'LIFE_INSURANCE',
]);
export type CallCampaignProductType = z.infer<typeof CallCampaignProductType>;

export interface GetCallCampaignPayload {
  product: CallCampaignProductType;
  placement: CampaignPlacement;
  site: string;
  src: string;
  call_type: CallType;
  publisher_click_id: string;
  session_id: string;
  user_id: string;
  sub_id: string | number;
  partner_sub_id: string;
  experiment_id: string;
  variation_id: string;
  device: string;
  state: string;
  zip: string;
  request_url: string;
  smid: string;
  profile: {
    qle?: number;
    familySize: number;
    fpl: string;
    tobacco: string | null;
    gender: 'm' | 'f';
    age: number;
  };
}

/**
 * @See https://github.com/healthcarecom/sem-content#get-campaign-of-calls
 */

export interface GetCallCampaignResponse {
  data: Data;
  error?: string;
  status?: number;
}

interface Data {
  placement: string;
  logo: string | null;
  state: string;
  zip: string;
  impression_id: string;
  advertiser: Advertiser;
  phone: Phone;
  schedule: Schedule;
}

interface Advertiser {
  name: string;
  logo?: string | null;
}

interface Phone {
  promo_number_formatted: string;
  promo_number: string;
  tracking_url?: string | null;
  /**
   * Invoca allocation path, e.g. `844948/allocate_number.json?ring_pool_key=…`.
   * The leading number is the Ring Pool ID. The query string carries the
   * `ring_pool_key` credential, so never log or forward this value as-is.
   */
  link_invoca?: string | null;
  tty_formatted: string;
}

export interface Schedule {
  sunday: Day;
  saturday: Day;
  tuesday: Day;
  Thursday: Day;
  wednesday: Day;
  friday: Day;
  monday: Day;
}

interface Day {
  from: string;
  to: string;
}
